// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LC5SM","delete":"styles_delete__35fGk","update":"styles_update__2ErpR","add":"styles_add__v-U-Y"};